import {Parceiro} from '@/soganhei'

import http from "@/http/service"



async function Ping(){
    return http.get(`/auth/ping`)
}
 
async function LoginParceiro(payload=Parceiro){

    const {login, senha} = payload

    const parceiro = {
        login, 
        senha, 
    }
    
    return http.post(`/auth/usuario`,parceiro)

}

export default {
    Ping, 
    LoginParceiro, 
}